import { Component, OnInit } from '@angular/core';
import { ViewModel } from '../error-log/error-log.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-error-log-detail-view',
    templateUrl: './error-log-detail-view.component.html',
    styleUrls: ['./error-log-detail-view.component.css'],
    standalone: false
})
export class ErrorLogDetailViewComponent implements OnInit {

  constructor(private snackBar: MatSnackBar) {

  }
  viewModel: ViewModel;

  divContent: HTMLDivElement;

  ngOnInit(): void {
    const state = history.state;
    //console.log(state.viewModel);

    this.viewModel = state.viewModel;
  }

  copyToClipboard(element: HTMLDivElement): void {
    this.divContent = element;
    
    const range = document.createRange();
    range.selectNode(element);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    // document.addEventListener('copy', (e: any) => {
    //   e.clipboardData.setData('text/html', window.getSelection().toString() );
    //   e.clipboardData.setData('text/plain', window.getSelection().toString() );
    //   e.preventDefault();
    // });
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
    
    this.snackBar.open('Copied to Clipboard', 'Dismiss', {
      duration: 3000
    });
  }
}

function HostListener(arg0: string, arg1: string[]) {
  throw new Error('Function not implemented.');
}

